var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, } from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';
export const Button = forwardRef((_a, ref) => {
    var { id, label, disabled, handler, classes, type = 'button', isEnterHandle, loading, children, primary = true } = _a, props = __rest(_a, ["id", "label", "disabled", "handler", "classes", "type", "isEnterHandle", "loading", "children", "primary"]);
    const handClick = () => {
        handler && handler();
    };
    const handleEnter = (event) => {
        event.key === 'Enter' && handClick();
    };
    useEffect(() => {
        isEnterHandle && window.addEventListener('keypress', handleEnter);
        return () => {
            window.removeEventListener('keypress', handleEnter);
        };
    }, [id]);
    const mainClasses = [
        styles.btn,
        primary && styles.btnPrimary,
        loading && styles.loading,
        disabled && styles.btnDisabled,
    ];
    classes && mainClasses.push(...classes);
    return (_jsx(_Fragment, { children: _jsx("button", Object.assign({ ref: ref, className: clsx(mainClasses), onClick: handClick, disabled: disabled, type: type }, (type === 'submit' && {
            onSubmit: handClick,
        }), props, { children: _jsxs("div", Object.assign({ className: styles.btnInner }, { children: [loading ? (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: styles.loader }, { children: _jsx("div", { className: styles.bubbleLoader }) })), _jsx("div", Object.assign({ style: { visibility: 'hidden' } }, { children: label }))] })) : (label), children && children] })) })) }));
});
Button.displayName = 'Button';
